import {
  objectiveProgress,
  type ObjectiveProgress,
  type ObjectiveProgressIcon,
  type GameState,
} from "@dailywars/core/engine";

import { getBuildingIconSrc } from "#/game/buildingSprites";
import { getSpriteUnitIconSrc } from "#/game/unitSprites";

function objectiveIconSrc(icon: ObjectiveProgressIcon): string {
  if (icon.type === "building") {
    return getBuildingIconSrc(icon.kind, icon.owner);
  }
  return getSpriteUnitIconSrc(icon.kind, icon.owner);
}

function ObjectiveProgressIconImage({ icon }: { icon: ObjectiveProgressIcon }) {
  return (
    <img
      src={objectiveIconSrc(icon)}
      alt=""
      aria-hidden
      className="size-5 shrink-0 sm:size-6"
      draggable={false}
    />
  );
}

function hasObjectiveCount(progress: ObjectiveProgress): boolean {
  return progress.count !== null && progress.target !== null && progress.icon !== null;
}

export function ObjectiveStatusBar({ state }: { state: GameState }) {
  const progress = objectiveProgress(state);
  const showCount = hasObjectiveCount(progress);

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-9 items-center justify-center border-t border-border px-2 text-center text-xs font-medium text-foreground sm:px-3"
    >
      <span>
        <span>{progress.label}</span>
        {showCount ? (
          <span className="text-muted-foreground">{` - ${progress.count}/${progress.target}`}</span>
        ) : null}
      </span>
      {showCount && progress.icon !== null ? (
        <span className="ml-1 inline-flex items-center" aria-hidden>
          <ObjectiveProgressIconImage icon={progress.icon} />
        </span>
      ) : null}
    </div>
  );
}
